import styled from 'styled-components';

const AvgTimeText = styled.p`
  align-items: center;
  display: flex;
  font-weight: 700;
  gap: 12px;
`;

const Wrapper = styled.div`
  border: 1px solid var(--color-neutral-50);
  border-radius: var(--size-border-radius-md);
  flex: 1;
  padding: var(--size-padding-16);
`;

const BarArea = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  gap: 12px;
`;

const Card = styled.div`
  background-color: var(--color-bg-weak);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  margin-bottom: var(--size-16);
  padding: var(--size-padding-16);
`;

const CardFooter = styled.div`
  padding: 0 4px;
  .item-content {
    flex: 1;
  }
`;

const Column = styled.div`
  max-width: calc(50% - 12px);
  width: 50%;
`;

const Rate = styled.div`
  font-weight: bold;
  text-align: right;
  width: 72px;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 24px;
`;

const SpeedArea = styled.div`
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: var(--size-20);
`;

const SpeedAreaTitle = styled.div`
  font-size: 28px;
  font-weight: 700;
`;

const AvgWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

export {
  AvgTimeText,
  AvgWrapper,
  BarArea,
  Card,
  CardFooter,
  Column,
  Rate,
  Row,
  SpeedArea,
  SpeedAreaTitle,
  Wrapper
};
